module.exports = __webpack_public_path__ + "static/media/bibeo_small.657e9894.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/bibeo_small.jpg
 ** module id = 669
 ** module chunks = 0
 **/